module.exports = __webpack_public_path__ + "img/about-us-bg.f3ec9a26.svg";